<template>
  <div class="user">
    <!-- <div class="photo">
      <img :src="getLogoURL" alt="user avatar" />
    </div> -->
    <div class="info">
      <a style="color: white">
        <span>
          {{ getFullName }}
        </span>
      </a>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import Session from "../../../Session";

export default {
  components: {
    CollapseTransition
  },
  data() {
    return {};
  },
  computed: {
    getFullName() {
      return Session.instance.user.fullName;
    },
    getLogoURL() {
      return "";
    }
  }
};
</script>
<style scoped>
.nav.nav-menu {
  margin-top: 0;
}
</style>
